/**
 * service-api-ueslms (Node/Express, GCP App Engine) taban URL'i.
 *
 * Secret gerektiren SSO adımları (K12Net OAuth token değişimi, Gradingly'nin UES'e
 * imzalı çağrıları) tarayıcıda değil bu serviste yapılır — bkz. K12Net.vue, Gradingly.vue.
 */
const isLocal = window.location.hostname === 'localhost';

/**
 * Node servisini de yerelden çalıştırmak için true yap.
 * Varsayılan false: eski davranışta yerelde bile canlı servis kullanılıyordu.
 */
const USE_LOCAL_SERVICE_API = false;

export const serviceApiBaseUrl = (isLocal && USE_LOCAL_SERVICE_API)
  ? 'http://localhost:4000'
  : 'https://ueslms-service-api.ey.r.appspot.com';
